import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { BASE_URL } from "../../api/api";
import PaymentMISHook from "./PaymentMISHook";
import { FaSearch } from "react-icons/fa";
import GlobalSearchhook from "../Review batches/GlobalSearchhook";

const InvoiceMIS = () => {
    const [paidData, setPaidData] = useState([]);
    const { VENDOR_LIST } = PaymentMISHook()
    const [selectedVendor, setSelectedVendor] = useState("");
    const [expandedBatch, setExpandedBatch] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
 const { handleSearch, searchText, setSearchText } = GlobalSearchhook()

    useEffect(() => {
        const fetchPaidData = async () => {
            try {
                const res = await fetch(`${BASE_URL}/GetPaidCasesMISList`);
                const data = await res.json();

                if (data.status) {
                    setPaidData(data.vendorList || [])
                } else {
                    Swal.fire("Error", data.message || "Failed to fetch data", "error");
                }
            } catch (error) {
                console.error("Error fetching Paid MIS data:", error);
                Swal.fire("Error", "Something went wrong while fetching data", "error");
            }
        };

        fetchPaidData();
    }, []);

    const filteredData = paidData.filter((item) => {
        if (selectedVendor && item.vendorName?.toLowerCase() !== selectedVendor.toLowerCase()) {
            return false;
        }

        if (fromDate || toDate) {
            const recordDate = new Date(item.records?.[0]?.paymentDate);
            if (fromDate && recordDate < new Date(fromDate)) return false;
            if (toDate && recordDate > new Date(toDate)) return false;
        }

        return true;
    });

    const formatTwoDecimals = (val) => {
        const num = Number(val);
        return isNaN(num) ? val : num.toFixed(2);
    };

    const MAIN_COLUMNS = [
        "vendorName",
        "batchNo",
        "InvoiceNo",
        "totalPaidRepairCharges",
        "totalPaidServiceCharges",
        "totalPaidAmount",
    ];

    const handleDownload = () => {
        if (filteredData.length === 0) return;

        const exportRows = [];

        filteredData.forEach((row) => {
            exportRows.push({
                Vendor: row.vendorName,
                "Batch No": row.batchNo,
                "Invoice No": row.invoiceNo,
                "Total Paid Repair Charges": formatTwoDecimals(row.totalPaidRepairCharges),
                "Total Paid Service Charges": formatTwoDecimals(row.totalPaidServiceCharges),
                "Total Paid Amount": formatTwoDecimals(row.totalPaidAmount),
            });

            row.records?.forEach((rec, i) => {
                exportRows.push({
                    Vendor: "",
                    "Batch No": "",
                    "Total Paid Repair Charges": "",
                    "Total Paid Service Charges": "",
                    "Total Paid Amount": "",
                    "Sr No.": i + 1,
                    "AA No": rec.aaNo,
                    // "Invoice No": rec.invoiceNo,
                    "IMEI No": rec.imeiNo,
                    "Paid Repair Charges": formatTwoDecimals(rec.paidTotalRepairCharges),
                    "Paid Service Charges": formatTwoDecimals(rec.paidTotalServiceCharges),
                    "Paid GST": formatTwoDecimals(rec.paidGST),
                    "Paid TDS": formatTwoDecimals(rec.paidTDS),
                    "Total Paid Amount Detail": formatTwoDecimals(rec.totalPaidAmount),
                    "UTR Number": rec.utr,
                    "Payment Date": rec.paymentDate?.split(" ")[0] || "-",
                    "Schedule Id": rec.scheduleId|| "-",
                    "Liquidation Date": rec.liquidationDate?.split(" ")[0] || "-",
                    "Reference Number": rec.referenceNumber|| "-",
                });
            });
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(exportRows);
        XLSX.utils.book_append_sheet(wb, ws, "Paid Payment MIS");
        XLSX.writeFile(wb, "PaidPaymentMIS.xlsx");
    };

    return (
        <div className="container">
            <div className="pt-3 d-flex flex-wrap gap-3 align-items-end" style={{ gap: "20px" }}>
                <div style={{ minWidth: "250px" }}>
                    <label className="mb-1 text-sm font-medium">Vendor Name</label>
                    <select
                        className="form-select"
                        value={selectedVendor}
                        onChange={(e) => setSelectedVendor(e.target.value)}
                    >
                        <option value="">All Vendors</option>
                        {VENDOR_LIST.map((v) => (
                            <option key={v} value={v}>
                                {v}
                            </option>
                        ))}
                    </select>
                </div>
                <div
                    className="review_batch_seach input-group"
                    style={{ maxWidth: "240px", marginRight: "10px" }}
                >
                    <div className="fa_search_main">
                        <span className="input-group-text bg-light fasearch">
                            <FaSearch className="text-muted" />
                        </span>
                    </div>
                    <input
                        type="text"
                        className="form-control bg-light border-start-0"
                        placeholder="Global Search"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                        style={{ borderLeft: "none", boxShadow: "none" }}
                    />
                </div>
                <div>
                    <label className="mb-1 text-sm font-medium">From Date</label>
                    <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />
                </div>

                <div>
                    <label className="mb-1 text-sm font-medium">To Date</label>
                    <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />
                </div>

                <div>
                    <button
                        className="btn btn-primary"
                        style={{ backgroundColor: "#7E00D1", border: 0, width: 200 }}
                        onClick={handleDownload}
                    >
                        <DownloadIcon /> Download MIS
                    </button>
                </div>
            </div>

            <div className="container mt-4" style={{ overflow: "auto" }}>
                {filteredData.length > 0 ? (
                    <Table className="bg-white text-center border-0 network_table mt-3">
                        <thead
                            style={{ backgroundColor: "#EEF4FF", position: "sticky", top: 0, zIndex: 1 }}
                        >
                            <tr className="text-dark fw-semibold table_th_border">
                                <th>View</th>
                                {MAIN_COLUMNS.map((col) => (
                                    <th key={col}>{col}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((row, idx) => {
                                const isExpanded = expandedBatch === row.batchNo;

                                return (
                                    <React.Fragment key={idx}>
                                        {/* 🔹 Main row */}
                                        <tr className="text-center border-bottom network_td_item">
                                            <td className="align-middle">
                                                <button
                                                    className="btn btn-link p-0"
                                                    onClick={() =>
                                                        setExpandedBatch(isExpanded ? null : row.batchNo)
                                                    }
                                                    title="View Details"
                                                >
                                                    <VisibilityIcon style={{ color: "#7E00D1" }} />
                                                </button>
                                            </td>

                                            <td>{row.vendorName}</td>
                                            <td>{row.batchNo}</td>
                                            <td>{row.invoiceNo}</td>
                                            <td>{formatTwoDecimals(row.totalPaidRepairCharges)}</td>
                                            <td>{formatTwoDecimals(row.totalPaidServiceCharges)}</td>
                                            <td>{formatTwoDecimals(row.totalPaidAmount)}</td>
                                        </tr>

                                        {/* 🔹 Expanded sub-table */}
                                        {isExpanded && (
                                            <tr>
                                                <td colSpan={MAIN_COLUMNS.length + 1}>
                                                    <div className="p-2">
                                                        <Table bordered size="sm" responsive>
                                                            <thead style={{ background: "#f7f7f7" }}>
                                                                <tr>
                                                                    <th>Sr No.</th>
                                                                    <th>AA No</th>
                                                                    {/* <th>Invoice No</th> */}
                                                                    <th>IMEI No</th>
                                                                    <th>Paid Repair Charges</th>
                                                                    <th>Paid Service Charges</th>
                                                                    <th>Paid GST</th>
                                                                    <th>Paid TDS</th>
                                                                    <th>Total Paid Amount</th>
                                                                    <th>UTR</th>
                                                                    <th>Payment Date</th>
                                                                    <th>Schedule ID</th>
                                                                    <th>Liquidation Date</th>
                                                                    <th>Reference Number</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {row.records?.map((rec, i) => (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{rec.aaNo}</td>
                                                                        {/* <td>{rec.invoiceNo}</td> */}
                                                                        <td>{rec.imeiNo}</td>
                                                                        <td>{formatTwoDecimals(rec.paidTotalRepairCharges)}</td>
                                                                        <td>{formatTwoDecimals(rec.paidTotalServiceCharges)}</td>
                                                                        <td>{formatTwoDecimals(rec.paidGST)}</td>
                                                                        <td>{formatTwoDecimals(rec.paidTDS)}</td>
                                                                        <td>{formatTwoDecimals(rec.totalPaidAmount)}</td>
                                                                        <td>{rec.utr}</td>
                                                                        <td>{rec.paymentDate?.split(" ")[0]}</td>
                                                                        <td>{rec.scheduleId}</td>
                                                                        <td>{rec.liquidationDate}</td>
                                                                        <td>{rec.referenceNumber}</td>

                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </Table>
                ) : (
                    <p className="mt-4 text-center text-muted">No data found</p>
                )}
            </div>
        </div>
    );
};

export default InvoiceMIS;
